import { type LabColorInput, toLabColor } from './toLabColor'

export const MATISSE_LITE_RECIPE_PATH = 'matisse-lite' as const
export const MATISSE_LITE_STORED_TYPE = 'matisse_lite'

const toSpaceNumber = (value: unknown): number | undefined => {
  if (value == null || value === '') return undefined
  const n = Number(String(value).replace(/mm/gi, '').trim())
  return Number.isFinite(n) ? n : undefined
}

const assignIfPresent = (
  payload: Record<string, unknown>,
  key: string,
  value: unknown,
) => {
  if (value == null || value === '') return
  payload[key] = value
}

const assignSpace = (
  payload: Record<string, unknown>,
  key: string,
  value: unknown,
) => {
  const space = toSpaceNumber(value)
  if (space != null) payload[key] = space
}

const assignLabColor = (
  payload: Record<string, unknown>,
  key: string,
  value: unknown,
) => {
  const lab = toLabColor(value as LabColorInput)
  if (lab) payload[key] = lab
}

const assignLabOrGuide = (
  payload: Record<string, unknown>,
  key: string,
  value: unknown,
) => {
  if (value == null || value === '') return
  if (typeof value === 'string') {
    payload[key] = value
    return
  }
  assignLabColor(payload, key, value)
}

type RegionValue<T> = {
  cervical?: T | null
  middle?: T | null
  incisal?: T | null
}

export const buildMatisseLitePayload = ({
  recipeType,
  stainingbrand,
  ceramicbrand,
  frameworkColor,
  frameworkThickness,
  targetColors,
  prepColors,
  availspace,
}: {
  recipeType?: string | null
  stainingbrand?: string | null
  ceramicbrand?: string | null
  frameworkColor?: unknown
  frameworkThickness?: unknown
  targetColors?: RegionValue<unknown>
  prepColors?: RegionValue<unknown>
  availspace?: RegionValue<unknown>
}): Record<string, unknown> => {
  const payload: Record<string, unknown> = {}
  const isTripleZone = recipeType === 'triple dentin'

  assignIfPresent(payload, 'recipe_type', recipeType)
  assignIfPresent(payload, 'stainingbrand', stainingbrand)
  assignIfPresent(payload, 'ceramicbrand', ceramicbrand)
  assignIfPresent(payload, 'framework_color', frameworkColor)
  assignSpace(payload, 'framework_thickness', frameworkThickness)

  assignLabColor(payload, 'targetcolor_middle', targetColors?.middle)
  assignLabOrGuide(payload, 'prepcolor_middle', prepColors?.middle)
  assignSpace(payload, 'availspace_middle', availspace?.middle)

  if (isTripleZone) {
    assignLabColor(payload, 'targetcolor_cervical', targetColors?.cervical)
    assignLabColor(payload, 'targetcolor_incisal', targetColors?.incisal)
    assignLabOrGuide(payload, 'prepcolor_cervical', prepColors?.cervical)
    assignLabOrGuide(payload, 'prepcolor_incisal', prepColors?.incisal)
    assignSpace(payload, 'availspace_cervical', availspace?.cervical)
    assignSpace(payload, 'availspace_incisal', availspace?.incisal)
  }

  return payload
}
